import { RECOVERY_BASE_URL } from "../../../config";
import { apiCall, mutateApiCall } from "../../../shared/axios/axios-config";
import { PrivateQuery } from "../../../shared/globals/utilsGlobalTypes";
import { useMutation } from "../../../shared/react-query/react-query-conf";
import { Auth } from "../model/sessionInterface";

/* Password recovery endpoint URLs.
 *
 * These are absolute, unlike every other call in this app, because recovery is
 * served by the new backend while the rest of the app still talks to the
 * monolith — axios ignores its configured baseURL for an absolute url, so this
 * is all it takes to address a second backend.
 *
 * The /core prefix is required: it is the API gateway route to the core
 * service, and the unprefixed paths 404 there. */
export const FORGOT_PASSWORD_URL = `${RECOVERY_BASE_URL}/core/forgot-password`;
export const SET_PASSWORD_URL = `${RECOVERY_BASE_URL}/core/set-password`;

export const ValidateToken = ({ token }: PrivateQuery) => {
  return apiCall({
    method: "POST",
    url: "/ValidateJwtToken",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const GetLogin = (data: Auth) =>
  apiCall({
    method: "POST",
    url: "/authenticate",
    data,
  });

/**
 * Step 1 of password recovery: requests the recovery email for the given account.
 * Public — no session token.
 *
 * Resolves 200 whether or not the email is registered; that is deliberate on the
 * backend side, so it must not be used to tell the user the address was unknown.
 */
export const RequestPasswordReset = (data: { email: string }) =>
  mutateApiCall({
    method: "POST",
    url: FORGOT_PASSWORD_URL,
    data,
  });

/**
 * Step 2 of password recovery: sets a new password using the one-time token from
 * the recovery email. Public — the recovery token itself authorizes the change.
 * Fails 400 with INVALID_OR_EXPIRED_TOKEN or VALIDATION_ERROR.
 */
export const SetPassword = (data: { token: string; newPassword: string }) =>
  mutateApiCall({
    method: "POST",
    url: SET_PASSWORD_URL,
    data,
  });

export const useRequestPasswordReset = () => useMutation(RequestPasswordReset);

export const useSetPassword = () => useMutation(SetPassword);

export const GetUser = ({ token }: PrivateQuery) =>
  apiCall({
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: "/User",
  });

export const GetPlants = ({ token }: PrivateQuery) =>
  apiCall({
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: "/Plants",
  });

export const GetPerson = ({ token }: PrivateQuery) =>
  apiCall({
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: "/Person",
  });
